export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "add_package_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Agregar paquete"])}
        }
      }
    }
  })
}